var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReadPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#E0DEDE",
    strokeWidth: 2,
    d: "M0.999997 15C0.999996 7.26802 7.26801 1 15 0.999999C22.732 0.999999 29 7.26801 29 15L29 29L15 29C7.26801 29 0.999997 22.732 0.999997 15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadPin);
export default __webpack_public_path__ + "static/media/read-pin.97ab2a0bd88ff1817d2bef4241320163.svg";
export { ForwardRef as ReactComponent };